import type { BoxProps, ButtonBaseProps } from "@mui/material";
import { Box, ButtonBase } from "@mui/material";
import type { Editor } from "@tiptap/react";
import { FormatBold, FormatItalic } from "mdi-material-ui";

const MarkButton = ({
  children,
  isActive,
  ...props
}: { isActive: boolean } & ButtonBaseProps) => (
  <ButtonBase
    sx={{
      p: 1,
      color: isActive ? "text.primary" : "text.secondary",
    }}
    {...props}
  >
    {children}
  </ButtonBase>
);

export const Toolbar = ({
  editor,
  ...props
}: { editor: Editor } & BoxProps) => (
  <Box
    {...props}
    sx={{
      display: "flex",
      alignItems: "center",
      px: 2,
      background: ({ palette }) => palette.grey["100"],
      ...props?.sx,
    }}
  >
    <MarkButton
      onClick={() => editor.chain().focus().toggleBold().run()}
      isActive={editor.isActive("bold")}
    >
      <FormatBold />
    </MarkButton>
    <MarkButton
      onClick={() => editor.chain().focus().toggleItalic().run()}
      isActive={editor.isActive("italic")}
    >
      <FormatItalic />
    </MarkButton>
  </Box>
);
